// extracted by mini-css-extract-plugin
export default {"label":"SitesStatistic_label__HgxDH","name-label":"SitesStatistic_name-label__RRH+5","count-label":"SitesStatistic_count-label__AsYSM"};